export default __webpack_public_path__ + "static/media/trophy.2f4144d6.png";